// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3AQ1k","buttons":"Footer_buttons__1U62M"};